import React, { FC } from "react";
import styled from "@emotion/styled";
import { Col, Row } from "antd";
import { GetFactoryOverviewCancelData } from "services/interface";
import { stringToCommaFormat } from "utils/nuberFormat";

interface ContentBodyProps {
  data: GetFactoryOverviewCancelData | undefined
}

const ContentBody:FC<ContentBodyProps> = ({ data }) => {
  return (
    <WeapperCard>
    <Row gutter={[16,16]} style={{ marginTop: 20 }}  >
      <Col span={8} >
        <WrapperContentAgent>
          <WrapperTextContent>
            <TextAmount>{stringToCommaFormat(data?.cancel_count ?? "0")}</TextAmount>
            <TextPercent>{stringToCommaFormat(data?.percent ?? "0")}</TextPercent>
          </WrapperTextContent>
        </WrapperContentAgent>
      </Col>
    </Row>
    </WeapperCard>
  );
};
export default ContentBody;

const WrapperContentAgent = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
`;


const WrapperTextContent = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  width: auto;
  border-radius: 0px;
  padding: 0px 0px 0px 10px;
`;

const TextAmount = styled.p`
  font-size: 36px;
  font-weight: 500;
  background-color: #ffffff;
`;

const WeapperCard = styled.div`
  display: flex;
  height: 62px;
`;

const TextPercent = styled.p`
  font-size: 12px;
  font-weight: 400;
  color: #ff0000;
  margin-left: 5px;
`;